<template>
  <div>
    <v-btn
      color="primary"
      class="mb-2 ml-8"
      :disabled="isAllTextFieldDisable || !isDone || isAcceptance"
      @click="isShowAddAcceptanceItemDialog = true"
    >
      {{ $t('common_new') }}
    </v-btn>
    <v-dialog v-model="isShowAddAcceptanceItemDialog" persistent fullscreen>
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="dialogAddInstallationAcceptanceItem">
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-checkbox
                    v-model="editedAcceptanceItem.IsCustomerDevice"
                    :label="$t('quotation_item_is_customer_device')"
                    required
                    :disabled="isAcceptance"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-autocomplete
                    v-model="editedAcceptanceItem.CustomerDeviceType"
                    :items="customerDeviceTypeList"
                    item-text="Name"
                    item-value="Type"
                    :label="$t('engineer_item_customer_device_type')"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    v-if="editedAcceptanceItem.IsCustomerDevice"
                    :disabled="isAcceptance"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-autocomplete
                    :items="bomList"
                    item-text="Name"
                    item-value="Id"
                    return-object
                    v-model="editedAcceptanceItem.BomId"
                    @change="setEditedAcceptanceBomId"
                    :disabled="isAcceptance"
                    label="Bom名稱"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ data.item.Name }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ data.item.Describe }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field v-model="editedAcceptanceItem.BomDescribe" label="Bom描述" disabled>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-checkbox
                    v-model="editedAcceptanceItem.IsNeedThrowResume"
                    label="確定轉拋履歷卡"
                    :disabled="isAcceptance"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <resume-item-filter-all-type-autocomplete
                    :fatherEditedItem="editedAcceptanceItem"
                    :editedItemIndex="editedAcceptanceItemIndex"
                    :itemName="'quotation_item_number'"
                    :customerDeviceType="editedAcceptanceItem.CustomerDeviceType"
                    @setEditedItem="setEditedItem"
                    :isAllTextFieldDisable="isAllTextFieldDisable"
                    v-if="editedAcceptanceItemIndex === -1"
                    refName="itemAutocomplete"
                    @keyupEnter="focusNextInput"
                  />
                  <ValidationProvider
                    :name="$t('quotation_item_number')"
                    rules="required"
                    v-slot="{ errors }"
                    v-else
                  >
                    <v-text-field
                      v-model="editedAcceptanceItem.Number"
                      :label="$t('quotation_item_number')"
                      disabled
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <ValidationProvider
                    :name="$t('quotation_item_name')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="editedAcceptanceItem.Name"
                      :label="$t('quotation_item_name')"
                      disabled
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <ValidationProvider
                    :name="$t('quotation_item_unit')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="editedAcceptanceItem.Unit"
                      :label="$t('quotation_item_unit')"
                      required
                      disabled
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <ValidationProvider
                    :name="$t('quotation_item_quantity')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="editedAcceptanceItem.Quantity"
                      :label="$t('quotation_item_quantity')"
                      required
                      clearable
                      :disabled="editedAcceptanceItemIndex !== -1 || isAcceptance"
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <ValidationProvider
                    :name="$t('installation_acceptance_item_real_quantity')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="editedAcceptanceItem.RealQuantity"
                      :label="$t('installation_acceptance_item_real_quantity')"
                      required
                      clearable
                      :disabled="isAcceptance"
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col
                  cols="12"
                  sm="3"
                  md="3"
                  xl="3"
                  lg="3"
                  v-if="
                    editedAcceptanceItem.HasSerialNumber &&
                      (!editedAcceptanceItem.IsCustomerDevice ||
                        (editedAcceptanceItem.IsCustomerDevice &&
                          editedAcceptanceItem.CustomerDeviceType === 3))
                  "
                >
                  <v-autocomplete
                    v-model="editedAcceptanceItem.SerialNumber"
                    :items="throwResumeList"
                    item-text="Number"
                    item-value="Number"
                    :label="$t('quotation_item_serialnumber')"
                    required
                    :disabled="!editedAcceptanceItem.HasSerialNumber"
                    return-object
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    v-if="editedAcceptanceItemIndex === -1"
                    @click="getItemSerialNumber"
                  >
                  </v-autocomplete>
                  <v-text-field
                    v-model="editedAcceptanceItem.SerialNumber.Number"
                    :label="$t('quotation_item_serialnumber')"
                    disabled
                    v-else
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-autocomplete
                    v-model="editedAcceptanceItem.InstallPosition"
                    :items="allInstallPositionType"
                    item-text="Name"
                    item-value="Type"
                    :label="$t('quotation_item_install_position')"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    :disabled="isAcceptance"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <ValidationProvider
                    :name="$t('installation_acceptance_item_reason')"
                    rules="required"
                    v-slot="{ errors }"
                    v-if="
                      editedAcceptanceItem.Quantity * 1 !== editedAcceptanceItem.RealQuantity * 1
                    "
                  >
                    <v-textarea
                      outlined
                      v-model="editedAcceptanceItem.Reason"
                      :label="$t('installation_acceptance_item_reason')"
                      :error-messages="errors[0]"
                      :disabled="editedAcceptanceItemIndex !== -1 && isAcceptance"
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <ValidationProvider
                    :name="$t('quotation_item_warranty_period')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="editedAcceptanceItem.WarrantyPeriod"
                      required
                      clearable
                      :error-messages="errors[0]"
                      :disabled="editedAcceptanceItemIndex !== -1 || isAcceptance"
                      @keyup.enter="focusNextInput"
                    >
                      <template v-slot:label>
                        <span class="red--text">
                          <strong>* </strong>
                        </span>
                        {{ $t('quotation_item_warranty_period') }}
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <ValidationProvider
                    :name="$t('installation_notice_item_buy_or_rent')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-autocomplete
                      v-model="editedAcceptanceItem.BuyOrRentType"
                      :items="allBuyOrRentType"
                      item-text="Name"
                      item-value="Type"
                      :disabled="isAcceptance"
                      required
                      :loading-text="$t('common_get_data')"
                      :no-data-text="$t('common_no_results')"
                      :error-messages="errors[0]"
                      @keyup.enter="setBuyOrRentTypeAutocomplete"
                      ref="buyOrRentTypeAutocomplete"
                    >
                      <template v-slot:label>
                        <span class="red--text">
                          <strong>* </strong>
                        </span>
                        {{ $t('installation_notice_item_buy_or_rent') }}
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-autocomplete
                    v-model="editedAcceptanceItem.Custody"
                    :items="allCustodyType"
                    item-text="Name"
                    item-value="Type"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    :disabled="isAcceptance"
                    :label="$t('resume_item_custody')"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="editedAcceptanceItem.HasAuthorize">
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-autocomplete
                    :items="gmTypeList"
                    item-text="Name"
                    item-value="Type"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    v-model="editedAcceptanceItem.GmServerType"
                    label="GM"
                    :disabled="isAcceptance"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedAcceptanceItem.AuthorizeItemSerialNumber"
                    label="授權序號"
                    :disabled="isAcceptance"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="editedAcceptanceItem.Reason">
                <v-col>
                  <ValidationProvider
                    :name="$t('installation_acceptance_item_reason')"
                    rules="required"
                    v-slot="{ errors }"
                    v-if="
                      editedAcceptanceItem.Quantity * 1 !== editedAcceptanceItem.RealQuantity * 1
                    "
                  >
                    <v-textarea
                      outlined
                      v-model="editedAcceptanceItem.Reason"
                      :error-messages="errors[0]"
                      :disabled="isAcceptance"
                    >
                      <template v-slot:label>
                        <span class="red--text">
                          <strong>* </strong>
                        </span>
                        {{ $t('installation_acceptance_item_reason') }}
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                  <ValidationProvider
                    name="換GM Server原因"
                    rules="required"
                    v-slot="{ errors }"
                    v-else
                  >
                    <v-textarea
                      outlined
                      v-model="editedAcceptanceItem.Reason"
                      :error-messages="errors[0]"
                      :disabled="isAcceptance"
                    >
                      <template v-slot:label>
                        <span class="red--text">
                          <strong>* </strong>
                        </span>
                        換GM Server原因
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" text @click="closeEditAcceptanceItem">
            {{ $t('common_cancel') }}
          </v-btn>
          <v-btn color="success darken-1" text @click="addAcceptanceItem">
            {{ $t('common_confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  HttpInstallationAcceptance,
  HttpInstallPosition,
  HttpSerialNumber,
  HttpQuotation,
  HttpFix,
  HttpAuthorizeMapping,
  HttpBom
} from '@/js/http-Manager'
import ResumeItemFilterAllTypeAutocomplete from '@/components/ResumeItemFilterAllTypeAutocomplete.vue'
export default {
  components: { ResumeItemFilterAllTypeAutocomplete },
  name: 'AddAcceptanceItem',
  props: {
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    isAcceptance: {
      type: Boolean,
      default: false
    },
    isDone: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      gmTypeList: [],
      searchInstallationAcceptanceItems: '',
      isShowAddAcceptanceItemDialog: false,
      editedAcceptanceItemIndex: -1,
      bomList: [],
      editedAcceptanceItem: {
        BomId: '',
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        Reason: '',
        Custody: 0,
        IsNeedThrowResume: true
      },
      defaultAcceptanceItem: {
        BomId: '',
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        Reason: '',
        Custody: 0,
        IsNeedThrowResume: true
      },
      allBuyOrRentType: [],
      allInstallPositionType: [],
      itemSerialNumberList: [],
      customerDeviceTypeList: [],
      allCustodyType: [],
      selectNeedThrowItem: []
    }
  },
  async mounted () {
    await this.getAllBoms()
    await this.getBuyOrRentType()
    await this.getAllInstallPositionType()
    await this.getCustomerDeviceType()
    await this.getAllCustodyType()
    await this.getGmTypeList()
  },
  watch: {},
  computed: {
    throwResumeList () {
      var array = []
      this.itemSerialNumberList.forEach((element) => {
        if (!element.IsUsed) {
          array.push(element)
        }
      })
      return array
    }
  },
  methods: {
    setEditedAcceptanceBomId () {
      if (this.editedAcceptanceItem.BomId) {
        this.editedAcceptanceItem.BomName = this.editedAcceptanceItem.BomId.Name
        this.editedAcceptanceItem.BomDescribe = this.editedAcceptanceItem.BomId.Describe
        this.editedAcceptanceItem.BomId = this.editedAcceptanceItem.BomId.Id
        this.editedAcceptanceItem = JSON.parse(JSON.stringify(this.editedAcceptanceItem))
      }
    },
    async getAllBoms () {
      let response = await HttpBom.GetAllBoms()
      this.bomList = response && response.status === 200 ? response.data.Data : []
    },
    async getGmTypeList () {
      let response = await HttpAuthorizeMapping.GetGmTypes()
      this.gmTypeList = response.status === 200 ? response.data.Data : []
    },
    setBuyOrRentTypeAutocomplete (event) {
      this.$refs.buyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.buyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    async getAllCustodyType () {
      let response = await HttpFix.GetCustodyType()
      this.allCustodyType = response.status === 200 ? response.data.Data : []
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    setEditedItem (val) {
      this.editedAcceptanceItem.ItemId = val.Id
      this.editedAcceptanceItem.Number = val.Number
      this.editedAcceptanceItem.Name = val.Name
      this.editedAcceptanceItem.Unit = val.Unit
      this.editedAcceptanceItem.Price = val.Price
      this.editedAcceptanceItem.IsMonthItem = val.IsMonthItem
      this.editedAcceptanceItem.IsDelete = val.IsDelete
      this.editedAcceptanceItem.StoreNo = val.StoreNo
      this.editedAcceptanceItem.RepairPrice = val.RepairPrice
      this.editedAcceptanceItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedAcceptanceItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedAcceptanceItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedAcceptanceItem.HasSerialNumber = val.HasSerialNumber
      this.editedAcceptanceItem.HasAuthorize = val.HasAuthorize
      this.editedAcceptanceItem = JSON.parse(JSON.stringify(this.editedAcceptanceItem))
    },
    async getItemSerialNumber () {
      let param = {
        itemId: this.editedAcceptanceItem.ItemId
      }
      let response = await HttpSerialNumber.GetSerialNumberFromItemId(param)
      this.itemSerialNumberList = response.status === 200 ? response.data.Data : []
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    async getBuyOrRentType () {
      let response = await HttpInstallationAcceptance.GetBuyOrRentTypes()
      this.allBuyOrRentType = response.status === 200 ? response.data.Data : []
    },
    closeEditAcceptanceItem () {
      this.isShowAddAcceptanceItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultAcceptanceItem)
        this.editedAcceptanceItem = JSON.parse(str)
        this.editedAcceptanceItemIndex = -1
      })
    },
    async addAcceptanceItem () {
      const isValid = await this.$refs.dialogAddInstallationAcceptanceItem.validate()
      if (isValid) {
        this.$emit('setAddAcceptanceItem', this.editedAcceptanceItem)
        this.closeEditAcceptanceItem()
      }
    }
  }
}
</script>
